import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import BtnOptions from "./BtnOptions";
import Translator from "../../../../components/helpers/Translator";
import { axiosPath } from "../../../../../routing/helpers/router";
import UserSelectStates from "../../../../components/form/Selects/UserSelectStates";
import useIsMounted from "../../../../components/hooks/useIsMounted";
import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";

const Report45Options = (props) => {
  const {
    handleOnSetFieldValue,
    handleOnSubmit,
    handleOnSave,
    values,
    selectedReport,
  } = props;
  const isMounted = useIsMounted();
  const [reportOptions, setReportOptions] = useState();
  const [loading, setLoading] = useState(true);
  const [selectedPlants, setSelectedPlants] = useState([]);

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    if (values?.plants !== selectedPlants) {
      setSelectedPlants(values?.plants);

      handleOnSetFieldValue("categories", []);
      setLoading(true);
      setReportOptions(undefined);
      axios
        .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
          report: 45,
          selectedReport,
          payload: values,
        })
        .then((r) => {
          if (isMounted.current) {
            setReportOptions(r.data);
            setLoading(false);
          }
        })
        .catch(() => "");
    }
  }, [values?.plants, selectedReport, selectedPlants]);
  // < LOAD REPORT OPTIONS //

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <UserSelectStates
            onHandleChange={(opt) => {
              handleOnSetFieldValue("states", opt);
            }}
            value={values?.states}
            getPermissionsFrom="client"
            hasSelectOptions
            hideNotApplicable
            hideObsolete
          />
        </div>
      </div>
      {loading && (
        <div className="alert alert-info">
          <Translator file="module-intelligence" name="loading.information" />
        </div>
      )}
      {reportOptions?.layouts && (
        <div className="row">
          <div className="col-sm-12">
            <AppMultiSelect
              options={reportOptions.layouts || []}
              onChange={(e) => handleOnSetFieldValue("layouts", e)}
              placeholder={ReactDOMServer.renderToString(
                <Translator
                  file="module-intelligence"
                  name="select.structure.elements"
                />
              )}
              title={<Translator file="module-intelligence" name="structure" />}
              value={values.layouts || []}
              icon={<AppRemixIcon icon="apps" />}
              hasSearchBox
              hasSelectOptions
            />
          </div>
        </div>
      )}
      {reportOptions?.categories && (
        <div className="row">
          <div className="col-sm-12">
            <AppMultiSelect
              options={reportOptions.categories || []}
              onChange={(e) => handleOnSetFieldValue("categories", e)}
              placeholder={ReactDOMServer.renderToString(
                <Translator
                  file="module-intelligence"
                  name="module.int.select-categories"
                />
              )}
              title={
                <Translator file="module-intelligence" name="categories" />
              }
              value={values.categories || []}
              icon={<AppRemixIcon icon="apps" />}
              hasSearchBox
              hasSelectOptions
            />
          </div>
        </div>
      )}
      {reportOptions?.categorieGroups && (
        <div className="row">
          <div className="col-sm-12">
            <AppMultiSelect
              options={reportOptions.categorieGroups || []}
              onChange={(e) => handleOnSetFieldValue("categorieGroups", e)}
              placeholder={ReactDOMServer.renderToString(
                <Translator
                  file="module-intelligence"
                  name="select.category.groups"
                />
              )}
              title={
                <Translator file="module-intelligence" name="category.groups" />
              }
              value={values.categorieGroups || []}
              icon={<AppRemixIcon icon="apps" />}
              isMulti
              hasSearchBox
              hasSelectOptions
            />
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12">
          <BtnOptions
            isDisabled={
              !values.states ||
              values.states.length === 0 ||
              (values.plants && values.plants.length === 0) ||
              (reportOptions?.categories &&
                (!values.categories || values.categories.length === 0))
            }
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </>
  );
};

export default Report45Options;
